import { useQuery } from "@tanstack/react-query";
import { bookingCheckinService } from "@/services/booking-checkin.service";

export const useBookingCheckin = (bookingId: string | undefined) => {
  return useQuery({
    queryKey: ["booking-checkin", bookingId],
    queryFn: () =>
      bookingId ? bookingCheckinService.getCheckinByBookingId(bookingId) : null,
    enabled: !!bookingId,
  });
};
